import { UIStrings } from '../uistrings.context';

export const strings: UIStrings = {
  unknownError: 'Unknown Error',
  rotate0Deg: '0 degree',
  rotate90Deg: '90 degree',
  rotate180Deg: '180 degree',
  rotate270Deg: '270 degree',
  thumbnails: 'Thumbnails',
  bookmarks: 'Bookmarks',
  noBookmarks: 'No bookmarks',
  saveAs: 'Save As',
  print: 'Print',
  metadata: 'Metadata',
  title: 'Title',
  author: 'Author',
  subject: 'Subject',
  keywords: 'Keywords',
  producer: 'Producer',
  creator: 'Creator',
  creationDate: 'Creation Date',
  modificationDate: 'Modification Date',
  search: 'Search',
  nextMatch: 'Next',
  previousMatch: 'Previous',
  matchCase: 'Match Case',
  matchWholeWord: 'Match Whole Word',
  matchConsecutive: 'Match Consecutive',
  attchments: 'Attachments',
  noAttachments: 'No Attachments',
  fileName: 'Name',
  fileSize: 'Size',
  fileCreationDate: 'Creation Date',
  download: 'Download',
  upload: 'Upload',
  signatures: 'Signatures',
  noSignatures: 'No Signatures',
  extract: 'Extract',
  pencil: 'Pencil',
  fillForm: 'Fill Form',
  addTextBox: 'Add Text Box',
  addStamp: 'Add Stamp',
  addImage: 'Add Image',
  selection: 'Selection',
  annotation: 'Annotation',
  stamps: 'Stamps',
  createStamp: 'Create Stamp',
  cancel: 'Cancel',
  exit: 'Exit',
  edit: 'Edit',
  open: 'Open',
  save: 'Save',
  commit: 'Commit',
  discard: 'Discard',
  uncommittedWarning:
    'You have changes that is not committed, do you want to save those changes ?',
  printing: 'Printing',
  remove: 'Remove',
  noFiles: 'No Files',
  merge: 'Merge',
  merging: 'Merging',
  extractPages: 'Extract Pages',
  extractText: 'Extract Text',
};
